import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import type { UserApi } from '@/modules/users/types';

import { usersQueryKeys } from './queryKeys';

export const useUserQuery = (
  userId: string | undefined,
  options?: Omit<
    UseQueryOptions<UserApi | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: usersQueryKeys.detail(userId),
    queryFn: userId
      ? async () => {
          const { data } = await fetchClient.GET(endpoints.user, {
            params: { path: { id: userId } },
          });
          return data;
        }
      : skipToken,

    ...options,
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};
